const reqwest = require('reqwest/reqwest.min');
const endpoints = require('endpoint/endpoint-service.js');
const ExceptionService = require('exceptions/exception-service.js');
const Q = require('q');
const _ = require('underscore/underscore-min');

const PipedriveService = (function (root, doc, undefined) {

    const filename = 'pipedrive-service.js';
    const pipedriveCustomFieldsMap = {
        'licence_number': '15469ebfefb2065691624dbd7fdbc9a9b7ca584b',
        'organisation_background': 'fa082b47b475bf58703b776fab0ed4f4a1ba1859'
    };
    let personParams;
    let dealParams;

    /**
     * Creates 3 specific objects in Pipedrive (Deal / Organisation / Person)
     * First, it creates the Person and Org - then, it creates the Deal + links the Person and Org
     * @param {requestParams} Object with key & values of the form input
     * @return {Promise} Success / Error of 3 created Pipedrive objects [Deal, Person, Org]
     */
    const postPipedriveForm = (requestParams) => {
        const orgParams = {
            name: requestParams.institution_name // Organisation name
        };
        personParams = {
            name: requestParams.name, // Your Name
            email: requestParams.email, // Work email
            phone: requestParams.phone // Phone number
        };
        dealParams = {
            title: requestParams.institution_name, // Deal Title
            [pipedriveCustomFieldsMap.licence_number]: requestParams.licences, // Number of licences
            [pipedriveCustomFieldsMap.organisation_background]: requestParams.message // Details of your organisation's language learning needs
        };

        const onPipedriveError = (error) => {
            throw new Error(`Creating one of the Pipedrive objects has failed - ${error}`);
        };

        const onCreateOrgSuccess = (orgId) => {
            const onSuccess = (personId) => {
                createPipedriveDeal({ orgId, personId });
            };
            createPipedrivePerson(orgId).then(onSuccess);
        };

        return createPipedriveObject('pipedriveCreateOrgAPI', orgParams)
            .then(onCreateOrgSuccess)
            .catch(onPipedriveError);
    };

    /**
     *
     * @param {Integer} Organisation ID
     * @return {Promise} Success / Error of creating a person
     */
    const createPipedrivePerson = (orgId) => {
        const linkedPersonParams = _.assign({}, personParams, { org_id: orgId });
        return createPipedriveObject('pipedriveCreatePersonAPI', linkedPersonParams);
    };

    /**
     * @param {Object} Object with integer IDs
     * @return {Promise} Success / error of creating a Deal with linked Person and Organisation
     */
    const createPipedriveDeal = ({ orgId, personId }) => {
        const linkedDealParams = _.assign({}, dealParams, { org_id: orgId, person_id: personId });
        return createPipedriveObject('pipedriveCreateDealAPI', linkedDealParams);
    };

    /**
     * Creates an object in Pipedrive - accepts 3 values for the endpoints:
     * - 'pipedriveCreateDealAPI': Creates a Deal
     * -- Minimum parameters needed: { title: 'Coffee & Unicorns' }
     * - 'pipedriveCreateOrgAPI' - Creates an Organisation
     * -- Minimum parameters needed: { name: 'Coffee & Unicorns' }
     * - 'pipedriveCreatePersonAPI' - Creates a Person
     * -- Minimum parameters needed: { name: 'Mr Glitter' }
     * @param  {Object} Object with data needed to create the object
     * @return {Promise}
     */
    const createPipedriveObject = (endpoint, data) => {

        let deferred = Q.defer();

        const onSuccess = (response) => {
            if (response && response.data && response.data.id) {
                deferred.resolve(response.data.id);
            } else {
                onError({
                    message: 'createPipedriveObject() - Failed creating an object',
                    error: response
                });
            }
        };

        const onError = (error) => {
            ExceptionService.handle('warning', {
                filename: filename,
                message: 'createPipedriveObject() - POST failure',
                data: error
            });
            deferred.reject(error);
        };

        let _url = endpoints.getAbsoluteEndpoint(endpoint);
        var postRequest = {
            url: _url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            withCredentials: false
        };

        reqwest(postRequest).then(onSuccess, onError);
        return deferred.promise;
    };

    return {
        postPipedriveForm: postPipedriveForm
    };
})(window, document);

module.exports = PipedriveService;
